/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./CheckboxGroup.css'); }
var Label_1 = require("./Label");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var ErrorMessage_1 = require("./ErrorMessage");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-checkboxGroup");
exports.CheckboxGroup = function CheckboxGroup(_a) {
    var children = _a.children, value = _a.value, onChange = _a.onChange, errorMessage = _a.errorMessage, className = _a.className, vertical = _a.vertical, label = _a.label, link = _a.link, onLinkClick = _a.onLinkClick, props = tslib_1.__rest(_a, ["children", "value", "onChange", "errorMessage", "className", "vertical", "label", "link", "onLinkClick"]);
    return (React.createElement("div", tslib_1.__assign({ className: classnames(moduleClassName(), vertical && moduleClassName("isVertical"), className) }, props),
        (!!label || !!link) && (React.createElement(Label_1.Label, { label: label, link: link, onLinkClick: onLinkClick })),
        React.createElement("div", { className: moduleClassName("content") }, React.Children.map(children, function (child) {
            if (!child || value === undefined) {
                return child;
            }
            var castedChild = child;
            var childName = castedChild.props.name;
            var checked = value.indexOf(childName) >= 0;
            var onCheckboxChange = function (evt, isChecked) {
                if (onChange === undefined) {
                    return;
                }
                var newValue = value.slice();
                if (isChecked && !checked) {
                    newValue.push(childName);
                }
                else if (!isChecked && checked) {
                    newValue.splice(value.indexOf(childName), 1);
                }
                onChange(evt, newValue);
            };
            return React.cloneElement(castedChild, {
                checked: checked,
                onChange: onCheckboxChange
            });
        })),
        !!errorMessage && React.createElement(ErrorMessage_1.ErrorMessage, { isLarge: true }, errorMessage)));
};
exports.CheckboxGroup.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func,
    vertical: PropTypes.bool,
    errorMessage: PropTypes.string,
    link: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    onLinkClick: PropTypes.func
};